/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';

import { asyncScheduler, Observable, scheduled } from 'rxjs';

import { IHybridMonitorService } from './IHybridMonitorService';
import { SCAN_ACTION_TYPES } from '@ids-constants';

import capabilities from './mock-data/capabilities.json';

@Injectable({
  providedIn: 'root',
})
export class MockHybridMonitorService implements IHybridMonitorService {
  startActiveScan(payload: any): Observable<any> {
    return scheduled([{}], asyncScheduler);
  }
  getActiveScan(param: { status?: any; projectId?: any; id?: any }): Observable<any> {
    return scheduled([{}], asyncScheduler);
  }
  getCapabilities(): Observable<any> {
    return scheduled([capabilities], asyncScheduler);
  }
  changeScanProgress(scan_id: number, action: SCAN_ACTION_TYPES): Observable<any> {
    return scheduled([{}], asyncScheduler);
  }
}
